import {Button, ButtonLink, ButtonPrimary} from '@homeaway/react-buttons';
import React from 'react';
import {withTranslationsAsProps} from '../../../components/translations';
import {SVGIcon} from '@homeaway/react-svg';
import {EDIT__16} from '@homeaway/svg-defs/lib/defs/EDIT__16';

export function EditButton({
    isEditing,
    isSaveable,
    labelCancel,
    labelDone,
    labelEdit,
    onCancel,
    onDone,
    onEdit
}) {
    return (
        <React.Fragment>
            {isEditing &&
                <React.Fragment>
                    <ButtonLink
                        data-wdio="tripboard-details__edit-button--cancel"
                        label={labelCancel}
                        onClick={onCancel}
                    />
                    <ButtonPrimary
                        data-wdio="tripboard-details__edit-button--done"
                        disabled={!isSaveable}
                        label={labelDone}
                        onClick={onDone}
                    />
                </React.Fragment>
            }
            {!isEditing &&
                <Button
                    aria-label={labelEdit}
                    className="btn-icon-responsive edit-button"
                    data-wdio="tripboard-details__edit-button"
                    label={
                        <React.Fragment>
                            <span className="hidden-xs">{labelEdit}</span>
                            <SVGIcon inlineFlex markup={EDIT__16} className="visible-xs"/>
                        </React.Fragment>
                        }
                    onClick={onEdit}
                />
            }
        </React.Fragment>
    );
}

export default withTranslationsAsProps({
    'tripboards.cancel': 'labelCancel',
    'tripboards.done': 'labelDone',
    'tripboards.main.edit': 'labelEdit'
})(EditButton);


// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/edit-button.js